// store/slices/deviceSlice.js
import { createSlice } from "@reduxjs/toolkit";

const deviceSlice = createSlice({
  name: "device",
  initialState: {
    deviceInfo: null,
  },
  reducers: {
    setDeviceInfo: (state, action) => {
      state.deviceInfo = action.payload;
    },
  },
});

export const { setDeviceInfo } = deviceSlice.actions;
export default deviceSlice.reducer;
